import { YesNoAlert } from "cpl-react-common/components/Alerts/YesNo";
import { Style } from "cpl-react-common/Helpers/AlertHelpers";
import { useSelector } from "react-redux";
import { selectErrorProcess, selectShowError, setShowError } from "./BackgroundActivitySlice";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getRedirectRouteForServiceType } from "./getRedirectRouteForServiceType";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

export const BackgroundActivityErrorAlert: React.FC = () => {
  const dispatch = useDispatch();
  const error = useSelector(selectErrorProcess);
  const showError = useSelector(selectShowError);
  const currentPath = useLocation();
  const [showAsAlert, setShowAsAlert] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (showError) {
      if (currentPath.pathname != getRedirectRouteForServiceType(error!.serviceType)) {
        setShowAsAlert(true);
      } else {
        toast.warning("This current process has failed. Please modify your selections and try again");
        dispatch(setShowError(false));
      }
    }
  }, [currentPath, dispatch, error, showError]);

  const handleResponse = (answer: boolean) => {
    setShowAsAlert(false);
    dispatch(setShowError(false));
    if (answer) {
      navigate(getRedirectRouteForServiceType(error!.serviceType));
    }
  };

  return (
    <YesNoAlert
      style={Style.Warning}
      showAlert={showAsAlert && showError}
      alertText={`${error?.message} Would you to like navigate to the failed process?`}
      alertTitle="Process Error"
      callBack={handleResponse}
    />
  );
};
